<button class="btn-count" [class.has-count]="count" [attr.aria-label]="srSubtitle" (click)="onToggled($event)" type="button">
  <rma-icon [glyph]="matIcon" />
</button>
